<template>
  <div>
    <div v-if="jobs.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
      No jobs configured yet
    </div>

    <table v-else class="w-full text-left">
      <thead class="bg-gray-100 dark:bg-gray-700">
        <tr>
          <th
            v-for="col in columns"
            :key="col.key"
            class="py-2 px-4 text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {{ col.label }}
          </th>
          <th class="py-2 px-4 text-sm font-medium text-gray-700 dark:text-gray-300 text-right">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(job, index) in jobs"
          :key="job.id"
          :class="[
            'border-b dark:border-gray-700',
            index % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-900'
          ]"
        >
          <td
            v-for="col in columns"
            :key="col.key"
            class="py-3 px-4 text-sm"
          >
            <template v-if="col.emptyText && !job[col.key]">
              <span class="text-gray-400 dark:text-gray-500 italic">{{ col.emptyText }}</span>
            </template>
            <template v-else-if="col.formatter">
              {{ col.formatter(job[col.key]) }}
            </template>
            <template v-else-if="Array.isArray(job[col.key])">
              <span class="text-xs bg-gray-200 dark:bg-gray-600 px-2 py-1 rounded">
                {{ job[col.key].length }} items
              </span>
            </template>
            <template v-else>
              {{ job[col.key] ?? 'N/A' }}
            </template>
          </td>
          <td class="py-3 px-4 text-right">
            <button
              v-if="canEdit"
              @click="$emit('edit', job)"
              class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 mr-3"
              title="Edit"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </button>
            <button
              v-if="canDelete"
              @click="$emit('delete', job)"
              class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
              title="Delete"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
              </svg>
            </button>
            <span
              v-if="!canEdit && !canDelete"
              class="text-xs text-gray-400 dark:text-gray-500 italic"
            >Read only</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "JobTable",
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["edit", "delete"],
};
</script>
